import { pairHasOpenIssue, useTaskActivitiesForServiceRequest } from '@commenda/api/tasks';
import { ServiceRequestComplianceItem } from '@commenda/types/src/service-request/types';
import { cn } from '@commenda/utils';
import { TaskStatus } from '@prisma/client';
import { getServiceRequestServiceDetails } from '../../../constants';
import { ServiceRequestTaskProps } from '../../../types';
import { ComplianceTaskDueDate } from '../../../utils';

type ServiceRequestTaskComplianceCardPreviewProps = Omit<
  ServiceRequestTaskProps,
  'taskRole' | 'isTimelineView'
> & {
  complianceItem: ServiceRequestComplianceItem;
};

function ServiceRequestTaskComplianceCardPreview({
  task,
  config,
  state,
  complianceItem,
  context,
}: ServiceRequestTaskComplianceCardPreviewProps) {
  const leftIcon = config.getLeftIcon(state.status);
  const stateConfig = config.getStateConfig(state);

  const { data: activityFeed } = useTaskActivitiesForServiceRequest(
    context.serviceRequest?.id
  );
  const taskHasOpenIssue =
    task.status !== TaskStatus.COMPLETED &&
    pairHasOpenIssue(activityFeed?.activities, task);

  const isInProgress = state.status === TaskStatus.IN_PROGRESS;

  const disabled = state.status === TaskStatus.BACKLOG;

  const dueDate = complianceItem?.currentlyActiveTransition?.dueDate;

  return (
    <div
      className={cn(
        'flex justify-between items-center h-16 p-xl',
        disabled
          ? 'bg-bg-primary-hover cursor-not-allowed'
          : taskHasOpenIssue
            ? 'border-border-error'
            : ''
      )}
    >
      <div className="flex flex-col gap-xs txt-small-medium">
        <div
          className={cn(
            'flex gap-md items-center',
            isInProgress ? 'text-text-warning font-medium' : '',
            disabled ? 'text-text-disabled' : ''
          )}
        >
          {stateConfig.label}
        </div>
        {complianceItem ? (
          <div className="flex gap-md text-text-secondary txt-extra-small-regular mr-md">
            <span className="truncate">{complianceItem.title}</span>
            <span>•</span>
            <div className="shrink-0">
              <ComplianceTaskDueDate dueDate={dueDate} />
            </div>
          </div>
        ) : (
          <span>
            {
              getServiceRequestServiceDetails(context.serviceRequest)
                .displayName
            }
          </span>
        )}
      </div>
      <div className="flex items-center gap-md">{stateConfig.actions}</div>
    </div>
  );
}

export { ServiceRequestTaskComplianceCardPreview };
